<template>
  <div class="page-wrapper">   
    <div class="page-title">
      <CIcon name="cil-paw" /> Species Editor
    </div>
        <CRow v-if="loading">
            <CCol md="12">
                <clip-loader ></clip-loader>
            </CCol>
        </CRow>
        <CRow v-else>
            <CCol md="8">
                <CCard>
                    <CCardHeader>
                        <h6>Species Information</h6>
                        <small>Add or update species</small>
                    </CCardHeader>
                    <CCardBody>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CSelect
                                            label="Class"
                                            placeholder="Select a one"
                                            :options="options.class"
                                            :value.sync="selected.class"
                                        />      
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CInput
                                            label="Family Name"
                                            type="text"
                                            :value="selected.family"
                                            v-model="selected.family"
                                            @keyup="getList('groupName')"
                                        /> 
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CInput
                                            label="Group Name"
                                            type="text"
                                            :value="selected.group"
                                            v-model="selected.group"
                                            @keyup="getList('categoryName')"
                                        /> 
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CInput
                                            label="Identity Name"
                                            type="text"
                                            :value="selected.identity"
                                            v-model="selected.identity"
                                            @keyup="getList('identityName')"
                                        /> 
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CInput
                                            label="Scientific Name"
                                            type="text"
                                            :value="selected.scientific"
                                            v-model="selected.scientific"
                                            @keyup="getList('scientificName')"
                                        /> 
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CForm>
                                        <CInput
                                            label="IUCN Category"
                                            type="text"
                                            :value="selected.iucn"
                                            v-model="selected.iucn"
                                            @keyup="getList('iucnCategory')"
                                        /> 
                                    </CForm>
                                </CCol>
                            </CRow>

                    </CCardBody>
                    <CCardFooter class="text-center">
                        <CRow>
                            <CCol sm="4">
                                <CButton type="submit" color="danger" @click="deleteSpecies()" v-if="id != undefined"><CIcon name="cil-delete"/> Delete Species</CButton>
                            </CCol>
                            <CCol sm="4" class="text-center">
                                <div><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                            </CCol>
                            <CCol sm="4">
                                <CButton type="submit" color="primary" @click="updateSpecies()"><CIcon name="cil-check-circle"/> Save & Update</CButton>
                            </CCol>     
                        </CRow>                                    
                    </CCardFooter>   
                </CCard>
            </CCol>
            <CCol md="4">
                    <CCard>
                    <CCardHeader>
                        <CRow>
                        <CCol md="10">
                            <h6>List of available options</h6>
                            <small>Start typing to search</small>
                        </CCol>
                        <CCol md="2">
                            <clip-loader v-if="filterLoading == true"></clip-loader>
                        </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody v-if="items.length > 0" style="max-height : 500px; overflow : scroll">
                        <b-table 
                                hover
                                selectable
                                responsive
                                select-mode="single"
                                @row-selected="updateField"
                                :items="items"
                                :fields="fields"
                                style="cursor : pointer"
                                id="reportTable"
                            >
                                
                            </b-table>
                            
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
export default {
    name: 'SpeciesEdit',
    props : ['id'],
    components: {
            GridLoader,
            PulseLoader,
            ClipLoader
    },
    created() {
        if(this.id != undefined){
            this.getSpecies();
        }
    },
    data () {
        return {
            baseURL : store.state.baseURL,
            loading : false,
            filterLoading : false,
            options : {
                class : [
                    "aves",
                    "mammals",
                    "reptiles"
                ]
            },
            selected : {
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                iucn : null                                
            },    
            errors : [],
            searchText : '',
            items : [],
            currentPage : 1,
            type : '',
            fields : [
                {
                    key : 'data',
                    label : ''
                },
            ]
        }
    },
    methods: {
        reset(){
            this.loading = true;
            window.location.reload();
        },
        getSpecies(){
            this.loading = true;
            axios({
                url : this.baseURL + "animalData/get-one?id=" + this.id,
                headers : {
                    authorization : store.state.token
                },
                method : "GET",
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.selected = {
                        class       : res.data.data.class,
                        family      : res.data.data.groupName,
                        group       : res.data.data.categoryName,
                        identity    : res.data.data.identityName,
                        scientific  : res.data.data.scientificName,
                        iucn        : res.data.data.iucnCategory  
                    }; 
                }
                else
                {
                    this.selected = null;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        updateSpecies(){
            this.errors = [];
            if(this.selected.identity == null){
                this.errors.push("Please enter an identity name");
            }
            if(this.selected.class == null){
                this.errors.push("Please select a class");
            }
            if(this.selected.group == null){
                this.errors.push("Please enter a group name");
            }
            if(this.selected.family == null){
                this.errors.push("Please enter a family name");
            }
            if(this.selected.scientific == null){
                this.errors.push("Please enter a scientifi name");
            }
            if(this.selected.iucn == null){
                this.errors.push("Please enter an IUCN Category");
            }

            if(this.errors.length == 0){
                try{
                    this.loading = true;
                    axios({
                        url : this.baseURL + (this.id == undefined ? "animalData/create" : "animalData/update?id=" + this.id),
                        headers : {
                            authorization : store.state.token
                        },
                        method : "POST",
                        data : {
                            class           : this.selected.class,
                            family          : this.selected.family,
                            group           : this.selected.group,
                            identity        : this.selected.identity,
                            scientific      : this.selected.scientific,
                            iucnCategory    : this.selected.iucn,

                        }
                    })
                    .then(res => {
                        if(res.data.status)
                        {                     
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New species created!',
                                text: res.data.message
                            });
                            if(this.id == undefined)
                                this.$router.go(-1);
                            else{
                                this.getSpecies();
                            }
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Could not create new record!',
                                text: res.data.message
                            });
                            this.loading = false;
                        }
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Could not create new record!',
                            text: 'Something went wrong while creating new record! Please try again later'
                        });
                        console.log(err);
                        this.loading = false;
                    });

                }
                catch(e){
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Could not create new record!',
                        text: 'Something went wrong while creating new record! Please try again later'
                    });
                    console.log(e);
                    this.loading = false;
                }

            }
            else{
                this.showErrors();
            }

        },
        deleteSpecies(){
            if(confirm("Do you want to delete this record? This action cannot be undone!")){
                try{
                    this.loading = true;
                    axios({
                        url : this.baseURL + "animalData/delete",
                        headers : {
                            authorization : store.state.token
                        },
                        method : "POST",
                        data : {
                            id : this.id
                        }
                    })
                    .then(res => {
                        if(res.data.status)
                        {                     
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'Species Deleted!',
                                text: res.data.message
                            });
                            this.$router.go(-1);
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Could not delete species!',
                                text: res.data.message
                            });
                            this.loading = false;
                        }
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Could not delete species!',
                            text: 'Something went wrong while deleting species! Please try again later'
                        });
                        console.log(err);
                        this.loading = false;
                    });

                }
                catch(e){
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Could not delete species!',
                        text: 'Something went wrong while deleting species! Please try again later'
                    });
                    console.log(e);
                    this.loading = false;
                }
            }

        },
        showErrors(){
            for(var i in this.errors){
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Could not create new record!',
                    text: this.errors[i]
                });
            }
            
        },
        getList(type){
            this.filterLoading = true;
            this.type = type;
            let searchTextLocal;
            if(type == 'categoryName')
                searchTextLocal = this.selected.group;
            else if(type == 'groupName')
                searchTextLocal = this.selected.family;
            else if(type == 'identityName')
                searchTextLocal = this.selected.identity;
            else if(type == 'scientificName')
                searchTextLocal = this.selected.scientific;
            else if(type == 'iucnCategory')
                searchTextLocal = this.selected.iucn;

            if(searchTextLocal.length >= 3 || type =='iucnCategory'){
                axios({
                    url : this.baseURL + "animalData/search",
                    headers : {
                        authorization : store.state.token
                    },
                    method : "POST",
                    data : {
                        type : type,
                        searchText : searchTextLocal
                    }
                })
                .then(res => {
                    if(res.data.status)
                    {                     
                        this.items = res.data.data; 
                    }
                    else
                    {
                        this.items = []
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: res.data.message
                        });
                    }
                    this.filterLoading = false;
                })
                .catch(err => {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Error in loading data. Something went wrong!'
                    });
                    console.log(err);
                    this.filterLoading = false;
                    return [];
                });
            }

            this.filterLoading = false;
        },
        updateField(row){
            if(this.type == 'categoryName')
                this.selected.group = row[0]['data'];
            else if(this.type == 'groupName')
                this.selected.family = row[0]['data'];
            else if(this.type == 'identityName')
                this.selected.identity = row[0]['data'];
            else if(this.type == 'scientificName')
                this.selected.scientific = row[0]['data'];
            else if(this.type == 'iucnCategory')
                this.selected.iucn = row[0]['data'];
        }   
    }
}
</script>
<style scoped>
    table, th, td {
        border: 1px solid black;
    }
</style>
